module.exports = __webpack_public_path__ + "images/store_case_study/guitarbuyer-pic1_ccad9141ddd6aa2567044f6eb4d64b1e.png";